module.exports = __webpack_public_path__ + "img/wed-main.c0edd6b8.png";